export default "__VITE_ASSET__ulE7ro2u__"